import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import TikTokIcon from "@/components/icons/TikTokIcon";
import { BRAND } from "@/data/founder";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--cc-surface)]">
      <div className="cc-container py-20 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={BRAND.logo}
              alt="Calm & Connected"
              data-testid="footer-logo"
              className="h-28 md:h-32 w-auto rounded-3xl shadow-[0_10px_30px_rgba(0,0,0,0.08)]"
            />
            <p className="mt-7 text-[var(--cc-text-soft)] max-w-md leading-relaxed">
              A calm, supportive space to talk, process, and reconnect with yourself.
              No pressure. No judgment. Just support.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.18em] text-[var(--cc-text-soft)]/80">
              This is not therapy, counseling, or medical advice.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-serif text-lg mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Services", "/services"],
                ["Pricing", "/pricing"],
                ["Booking", "/booking"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="cc-link text-sm text-[var(--cc-text-soft)]"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-serif text-lg mb-4">Reach Out</h4>
            <ul className="space-y-3 text-sm text-[var(--cc-text-soft)]">
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${BRAND.email}`}
                  className="inline-flex items-center gap-2 cc-link"
                >
                  <Mail size={16} strokeWidth={1.5} /> {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href={`tel:${BRAND.phone}`}
                  className="inline-flex items-center gap-2 cc-link"
                >
                  <Phone size={16} strokeWidth={1.5} /> {BRAND.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3 pt-2">
                <a
                  data-testid="footer-tiktok"
                  href={BRAND.socials.tiktok}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="TikTok — @camilieyes"
                  className="w-10 h-10 rounded-full border border-[var(--cc-line)] flex items-center justify-center text-[var(--cc-text-soft)] hover:text-[var(--cc-primary)] hover:border-[var(--cc-primary)]/40 transition-colors"
                >
                  <TikTokIcon size={16} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--cc-line)] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-[var(--cc-text-soft)]">
            © {new Date().getFullYear()} Calm &amp; Connected. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
